import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d6ba69c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "fw-bold mb-5" }
const _hoisted_3 = { class: "mb-4 ms-3 fs-7" }
const _hoisted_4 = { class: "ms-3 fs-7" }
const _hoisted_5 = { class: "mb-5 ms-3 fs-7" }
const _hoisted_6 = { class: "bg-gray p-2 d-flex fw-bold" }
const _hoisted_7 = { class: "p-3 d-flex flex-column" }
const _hoisted_8 = { class: "mx-2 fs-7" }
const _hoisted_9 = { class: "mx-2 fs-7" }
const _hoisted_10 = { class: "d-flex ms-4" }
const _hoisted_11 = { class: "fw-bold col-lg-2" }
const _hoisted_12 = { class: "col-lg-6" }
const _hoisted_13 = { class: "bg-gray p-2 d-flex fw-bold" }
const _hoisted_14 = { class: "p-3 d-flex flex-column" }
const _hoisted_15 = { class: "mx-2 fs-7" }
const _hoisted_16 = { class: "mx-2 fs-7" }
const _hoisted_17 = { class: "bg-gray p-2 fw-bold d-flex" }
const _hoisted_18 = { class: "p-3 d-flex flex-column" }
const _hoisted_19 = { class: "mx-2 fs-7 break-spaces" }
const _hoisted_20 = { class: "row mb-5" }
const _hoisted_21 = { class: "col-lg-6 px-4 stripe-table" }
const _hoisted_22 = { class: "label-btn mt-3 bg-form d-flex justify-content-center align-items-center fw-bold" }
const _hoisted_23 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_24 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_25 = { class: "row mx-0 px-0 col-lg-7 mt-2 d-flex" }
const _hoisted_26 = ["for"]
const _hoisted_27 = ["value", "id"]
const _hoisted_28 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_29 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_30 = { class: "row mx-0 px-0 col-lg-7 mt-2 d-flex" }
const _hoisted_31 = ["for"]
const _hoisted_32 = ["value", "id"]
const _hoisted_33 = { class: "mb-5 mb-lg-0 row p-2 mx-0" }
const _hoisted_34 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_35 = { class: "row mx-0 px-0 col-lg-7 mt-2 d-flex" }
const _hoisted_36 = ["for"]
const _hoisted_37 = ["value", "id"]
const _hoisted_38 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_39 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_40 = { class: "row mx-0 px-0 col-lg-7 mt-2 d-flex" }
const _hoisted_41 = ["for"]
const _hoisted_42 = ["value", "id"]
const _hoisted_43 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_44 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_45 = { class: "row mx-0 px-0 col-lg-7 mt-2 d-flex" }
const _hoisted_46 = ["for"]
const _hoisted_47 = ["value", "id"]
const _hoisted_48 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_49 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_50 = { class: "row mx-0 px-0 col-lg-7 mt-2 d-flex" }
const _hoisted_51 = ["for"]
const _hoisted_52 = ["value", "id"]
const _hoisted_53 = { class: "col-lg-6 px-4 stripe-table" }
const _hoisted_54 = { class: "label-btn mt-3 bg-form d-flex justify-content-center align-items-center fw-bold" }
const _hoisted_55 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_56 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_57 = { class: "row mx-0 px-0 col-lg-7 mt-2 d-flex" }
const _hoisted_58 = ["for"]
const _hoisted_59 = ["value", "id"]
const _hoisted_60 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_61 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_62 = { class: "row mx-0 px-0 col-lg-7 mt-2 d-flex" }
const _hoisted_63 = ["for"]
const _hoisted_64 = ["value", "id"]
const _hoisted_65 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_66 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_67 = { class: "row mx-0 px-0 col-lg-7 mt-2 d-flex" }
const _hoisted_68 = ["for"]
const _hoisted_69 = ["value", "id"]
const _hoisted_70 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_71 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_72 = { class: "row mx-0 px-0 col-lg-7 mt-2 d-flex" }
const _hoisted_73 = ["for"]
const _hoisted_74 = ["value", "id"]
const _hoisted_75 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_76 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_77 = { class: "row mx-0 px-0 col-lg-7 mt-2 d-flex" }
const _hoisted_78 = ["for"]
const _hoisted_79 = ["value", "id"]
const _hoisted_80 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_81 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_82 = { class: "row mx-0 px-0 col-lg-7 mt-2 d-flex" }
const _hoisted_83 = ["for"]
const _hoisted_84 = ["value", "id"]
const _hoisted_85 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_86 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_87 = { class: "row mx-0 px-0 col-lg-7 mt-2 d-flex" }
const _hoisted_88 = ["for"]
const _hoisted_89 = ["value", "id"]
const _hoisted_90 = { class: "row" }
const _hoisted_91 = { class: "col-lg-12 px-4" }
const _hoisted_92 = { class: "label-btn mt-3 bg-form d-flex justify-content-center align-items-center fw-bold" }
const _hoisted_93 = { class: "mb-5 mb-lg-0 row bg-light mx-0 p-2" }
const _hoisted_94 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_95 = { class: "col-lg-3" }
const _hoisted_96 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_97 = { class: "row mx-0 px-0 col-lg-3 mt-2 d-flex ms-4" }
const _hoisted_98 = ["for"]
const _hoisted_99 = ["value", "id"]
const _hoisted_100 = {
  key: 0,
  class: "col-lg-3"
}
const _hoisted_101 = ["value"]
const _hoisted_102 = { key: 0 }
const _hoisted_103 = { class: "w-max-content main-title-option-child" }
const _hoisted_104 = { class: "mb-5 mb-lg-0 row p-2 mx-0" }
const _hoisted_105 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_106 = { class: "col-lg-3" }
const _hoisted_107 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_108 = { class: "row mx-0 px-0 col-lg-3 mt-2 d-flex ms-4" }
const _hoisted_109 = ["for"]
const _hoisted_110 = ["value", "id"]
const _hoisted_111 = {
  key: 0,
  class: "col-lg-3"
}
const _hoisted_112 = ["value"]
const _hoisted_113 = { key: 0 }
const _hoisted_114 = { class: "w-max-content main-title-option-child" }
const _hoisted_115 = { class: "mb-5 mb-lg-0 row bg-light mx-0 p-2" }
const _hoisted_116 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_117 = { class: "col-lg-3" }
const _hoisted_118 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_119 = { class: "row mx-0 px-0 col-lg-3 mt-2 d-flex ms-4" }
const _hoisted_120 = ["for"]
const _hoisted_121 = ["value", "id"]
const _hoisted_122 = {
  key: 0,
  class: "col-lg-3"
}
const _hoisted_123 = ["value"]
const _hoisted_124 = { key: 0 }
const _hoisted_125 = { class: "w-max-content main-title-option-child" }
const _hoisted_126 = { class: "mb-5 mb-lg-0 row p-2 mx-0" }
const _hoisted_127 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_128 = { class: "col-lg-3" }
const _hoisted_129 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_130 = { class: "row mx-0 px-0 col-lg-3 mt-2 d-flex ms-4" }
const _hoisted_131 = ["for"]
const _hoisted_132 = ["value", "id"]
const _hoisted_133 = {
  key: 0,
  class: "col-lg-3"
}
const _hoisted_134 = ["value"]
const _hoisted_135 = { key: 0 }
const _hoisted_136 = { class: "w-max-content main-title-option-child" }
const _hoisted_137 = { class: "mb-5 mb-lg-0 row bg-light mx-0 p-2" }
const _hoisted_138 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_139 = { class: "col-lg-3" }
const _hoisted_140 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_141 = { class: "row mx-0 px-0 col-lg-3 mt-2 d-flex ms-4" }
const _hoisted_142 = ["for"]
const _hoisted_143 = ["value", "id"]
const _hoisted_144 = {
  key: 0,
  class: "col-lg-3"
}
const _hoisted_145 = ["value"]
const _hoisted_146 = { key: 0 }
const _hoisted_147 = { class: "w-max-content main-title-option-child" }
const _hoisted_148 = { class: "p-3 d-flex flex-column" }
const _hoisted_149 = { class: "mx-2 fs-7 break-spaces" }
const _hoisted_150 = { class: "mx-2 fs-7" }
const _hoisted_151 = { class: "row" }
const _hoisted_152 = { class: "col-lg-12 px-4" }
const _hoisted_153 = { class: "label-btn mt-3 bg-form d-flex justify-content-center align-items-center fw-bold" }
const _hoisted_154 = { class: "mb-5 mb-lg-0 row bg-light mx-0 p-2" }
const _hoisted_155 = { class: "col-lg-12" }
const _hoisted_156 = ["placeholder"]
const _hoisted_157 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_158 = { class: "p-3 d-flex flex-column" }
const _hoisted_159 = { class: "mx-2 fs-7 break-spaces" }
const _hoisted_160 = { class: "row mx-0 px-0 d-flex justify-content-center" }
const _hoisted_161 = { class: "col-lg-6 d-flex justify-content-center" }

import Button from '@/components/button/index.vue'
import ConfirmModal from '@/views/community-admin/alumni/register-form/components/ConfirmModal.vue'
import OptionForm from '@/views/community-admin/alumni/register-form/components/OptionForm.vue'
import SocialModal from '@/views/community-admin/alumni/register-form/components/SocialModal.vue'
import InvitationForm from '@/views/community-admin/alumni/register-form/components/InvitationForm.vue'
import Breadcrumb from '@/components/breadcrumb/index.vue'

import { translate } from '@/languages/i18n'
import { ref } from 'vue-demi'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { ALUMNI_REGISTER_FORM_STORE } from '@/store/constants'
import { computed, onMounted, nextTick, watch } from 'vue'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import useVuelidate from '@vuelidate/core'
import { maxLength, minLength, requiredIf } from '@vuelidate/validators'
import { DEFAULT_MIN_LENGTH } from '@/constants/number'
import { REGEX_EMOJI } from '@/constants/regex'
import adminRegisterService from '@/services/admin-register-alumni.service'
import { customMaxLength, scrollToErrors } from '@/utils'
import { InvitationKeyType } from '@/constants/type'
import { debounce } from 'lodash'
import commonService from '@/services/common.service'
import { ALUMNI_QUESTION_TYPE } from '@/constants/common'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const route = useRoute()
const data = computed(() => store.getters[ALUMNI_REGISTER_FORM_STORE.GETTERS.ENTRY_FORM])
const entry_form = ref({})
const invitationKeys = ref<Array<InvitationKeyType>>([])
const ListTypeOption = ref([
  { id: 0, name: translate('additionalInformationFreeText') },
  { id: 1, name: translate('additionalInformationSingleSelect') },
  { id: 2, name: translate('additionalInformationMultipleSelect') },
])
const additionalData = ref({
  addl_info_1_type: ALUMNI_QUESTION_TYPE.FREE_TEXT,
  addl_info_2_type: ALUMNI_QUESTION_TYPE.FREE_TEXT,
  addl_info_3_type: ALUMNI_QUESTION_TYPE.FREE_TEXT,
  addl_info_4_type: ALUMNI_QUESTION_TYPE.FREE_TEXT,
  addl_info_5_type: ALUMNI_QUESTION_TYPE.FREE_TEXT,
  addl_info_1_list: [''],
  addl_info_2_list: [''],
  addl_info_3_list: [''],
  addl_info_4_list: [''],
  addl_info_5_list: [''],
})

const checkExistData = (arr) => {
  if (arr && arr?.length > 0) {
    return arr
  }
  return ['']
}

onMounted(async () => {
  try {
    await store.dispatch(ALUMNI_REGISTER_FORM_STORE.ACTIONS.SET_ENTRY_FORM, route?.params?.id)

    entry_form.value = data.value
    additionalData.value = {
      addl_info_1_type: data.value?.additional_information_1_setting?.type || ALUMNI_QUESTION_TYPE.FREE_TEXT,
      addl_info_2_type: data.value?.additional_information_2_setting?.type || ALUMNI_QUESTION_TYPE.FREE_TEXT,
      addl_info_3_type: data.value?.additional_information_3_setting?.type || ALUMNI_QUESTION_TYPE.FREE_TEXT,
      addl_info_4_type: data.value?.additional_information_4_setting?.type || ALUMNI_QUESTION_TYPE.FREE_TEXT,
      addl_info_5_type: data.value?.additional_information_5_setting?.type || ALUMNI_QUESTION_TYPE.FREE_TEXT,
      addl_info_1_list: checkExistData(data.value?.additional_information_1_setting?.data),
      addl_info_2_list: checkExistData(data.value?.additional_information_2_setting?.data),
      addl_info_3_list: checkExistData(data.value?.additional_information_3_setting?.data),
      addl_info_4_list: checkExistData(data.value?.additional_information_4_setting?.data),
      addl_info_5_list: checkExistData(data.value?.additional_information_5_setting?.data),
    }
    const response = await adminRegisterService.getLinkAdminApi(route?.params?.id)
    invitationKeys.value = response.data.data
  } catch (error) {
    console.log(error)
  }
  // modalRef.value?.showConfirmModal()
})

const rules = computed(() => {
  return {
    additional_information_1_question: {
      required: requiredIf(entry_form.value.additional_information_1 === 1 || entry_form.value.additional_information_1 === 2),
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 50),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
    additional_information_2_question: {
      required: requiredIf(entry_form.value.additional_information_2 === 1 || entry_form.value.additional_information_2 === 2),
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 50),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
    additional_information_3_question: {
      required: requiredIf(entry_form.value.additional_information_3 === 1 || entry_form.value.additional_information_3 === 2),
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 50),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
    additional_information_4_question: {
      required: requiredIf(entry_form.value.additional_information_4 === 1 || entry_form.value.additional_information_4 === 2),
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 50),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
    additional_information_5_question: {
      required: requiredIf(entry_form.value.additional_information_5 === 1 || entry_form.value.additional_information_5 === 2),
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 50),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
    supplementary_information: {
      maxLength: (value: string) => customMaxLength(value, 1000),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
  }
})

const rulesAdd = computed(() => {
  return {
    addl_info_1_type: {
      requiredSelect: function (value) {
        if (value !== 0 || value !== 1 || value !== 2) return true
      },
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: maxLength(1),
    },
    addl_info_2_type: {
      requiredSelect: function (value) {
        if (value !== 0 || value !== 1 || value !== 2) return true
      },
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: maxLength(1),
    },
    addl_info_3_type: {
      requiredSelect: function (value) {
        if (value !== 0 || value !== 1 || value !== 2) return true
      },
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: maxLength(1),
    },
    addl_info_4_type: {
      requiredSelect: function (value) {
        if (value !== 0 || value !== 1 || value !== 2) return true
      },
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: maxLength(1),
    },
    addl_info_5_type: {
      requiredSelect: function (value) {
        if (value !== 0 || value !== 1 || value !== 2) return true
      },
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: maxLength(1),
    },
    addl_info_1_list: {
      $each: {
        required: requiredIf(true),
        minLength: minLength(DEFAULT_MIN_LENGTH),
        maxLength: (value: string) => customMaxLength(value, 50),
        emoji: function (value) {
          if (value !== '') return REGEX_EMOJI.test(value)
          return true
        },
      },
    },
    addl_info_2_list: {
      $each: {
        required: requiredIf(true),
        minLength: minLength(DEFAULT_MIN_LENGTH),
        maxLength: (value: string) => customMaxLength(value, 50),
        emoji: function (value) {
          if (value !== '') return REGEX_EMOJI.test(value)
          return true
        },
      },
    },
    addl_info_3_list: {
      $each: {
        required: requiredIf(true),
        minLength: minLength(DEFAULT_MIN_LENGTH),
        maxLength: (value: string) => customMaxLength(value, 50),
        emoji: function (value) {
          if (value !== '') return REGEX_EMOJI.test(value)
          return true
        },
      },
    },
    addl_info_4_list: {
      $each: {
        required: requiredIf(true),
        minLength: minLength(DEFAULT_MIN_LENGTH),
        maxLength: (value: string) => customMaxLength(value, 50),
        emoji: function (value) {
          if (value !== '') return REGEX_EMOJI.test(value)
          return true
        },
      },
    },
    addl_info_5_list: {
      $each: {
        required: requiredIf(true),
        minLength: minLength(DEFAULT_MIN_LENGTH),
        maxLength: (value: string) => customMaxLength(value, 50),
        emoji: function (value) {
          if (value !== '') return REGEX_EMOJI.test(value)
          return true
        },
      },
    },
  }
})
const v$ = useVuelidate(rules, entry_form)
const vAdd$ = useVuelidate(rulesAdd, additionalData)

const modalRef = ref()
const onSubmit = async (): Promise<void> => {
  v$.value.$touch()
  isCheckedNGSupplementaryInfo.value = false
  isCheckedNgWordAdditionalInformationQuestion.additional_information_1_question = false
  isCheckedNgWordAdditionalInformationQuestion.additional_information_2_question = false
  isCheckedNgWordAdditionalInformationQuestion.additional_information_3_question = false
  isCheckedNgWordAdditionalInformationQuestion.additional_information_4_question = false
  isCheckedNgWordAdditionalInformationQuestion.additional_information_5_question = false
  await checkNGSupplementaryInfo()
  await checkNgWordAdditionalInformationQuestion(1)
  await checkNgWordAdditionalInformationQuestion(2)
  await checkNgWordAdditionalInformationQuestion(3)
  await checkNgWordAdditionalInformationQuestion(4)
  await checkNgWordAdditionalInformationQuestion(5)

  while (
    !isCheckedNGSupplementaryInfo.value ||
    !isCheckedNgWordAdditionalInformationQuestion.additional_information_1_question ||
    !isCheckedNgWordAdditionalInformationQuestion.additional_information_2_question ||
    !isCheckedNgWordAdditionalInformationQuestion.additional_information_3_question ||
    !isCheckedNgWordAdditionalInformationQuestion.additional_information_4_question ||
    !isCheckedNgWordAdditionalInformationQuestion.additional_information_5_question
  ) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }
  if (
    v$.value.$invalid ||
    ngKeySupplementaryInfo.value ||
    ngWordAdditionalInformation1Question.value ||
    ngWordAdditionalInformation2Question.value ||
    ngWordAdditionalInformation3Question.value ||
    ngWordAdditionalInformation4Question.value ||
    ngWordAdditionalInformation5Question.value
  ) {
    nextTick(() => {
      scrollToErrors()
    })
    return
  }
  modalRef.value?.showConfirmModal()
}

const isCheckedNGSupplementaryInfo = { value: false }
const ngKeySupplementaryInfo = ref<boolean>(false)
const checkNGSupplementaryInfo = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.supplementary_information.$model })
  ngKeySupplementaryInfo.value = data.data?.data?.has_ngword
  isCheckedNGSupplementaryInfo.value = true
}, 200)

const ngWordAdditionalInformation1Question = ref<boolean>(false)
const ngWordAdditionalInformation2Question = ref<boolean>(false)
const ngWordAdditionalInformation3Question = ref<boolean>(false)
const ngWordAdditionalInformation4Question = ref<boolean>(false)
const ngWordAdditionalInformation5Question = ref<boolean>(false)

const isCheckedNgWordAdditionalInformationQuestion = {
  additional_information_1_question: false,
  additional_information_2_question: false,
  additional_information_3_question: false,
  additional_information_4_question: false,
  additional_information_5_question: false,
}

const checkNgWordAdditionalInformationQuestion = async (id) => {
  const queryData = { sentence: v$.value[`additional_information_${id}_question`].$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    eval(`ngWordAdditionalInformation${id}Question.value = ${data.data?.data?.has_ngword}`)
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNgWordAdditionalInformationQuestion[`additional_information_${id}_question`] = true
  }
}

const radio = ref([
  {
    value: 1,
    title: translate('CG40required'),
  },
  {
    value: 2,
    title: translate('CG40any'),
  },
  {
    value: 0,
    title: translate('CG40unnecessary'),
  },
])

const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('almunaiParManagement'),
    to: '',
    active: false,
  },
  {
    content: translate('formRegSetting'),
    to: '',
    active: true,
  },
]

const modalData = ref<Record<string, any>>({})
const setModalData = (data: Record<string, any>): void => {
  modalData.value = data
}

const addOptionAction = (type) => {
  // console.log('addOptionAction type: ', type)
  switch (type) {
    case 1:
      additionalData.value.addl_info_1_list = [...additionalData.value.addl_info_1_list, ...['']]
      break
    case 2:
      additionalData.value.addl_info_2_list = [...additionalData.value.addl_info_2_list, ...['']]

      break
    case 3:
      additionalData.value.addl_info_3_list = [...additionalData.value.addl_info_3_list, ...['']]

      break
    case 4:
      additionalData.value.addl_info_4_list = [...additionalData.value.addl_info_4_list, ...['']]

      break
    default:
      additionalData.value.addl_info_5_list = [...additionalData.value.addl_info_5_list, ...['']]
      break
  }
}

const deleteOptionAction = (type, index) => {
  // console.log('addOptionAction type: ', type)
  switch (type) {
    case 1: {
      let inputArr1 = [...additionalData.value.addl_info_1_list]
      inputArr1.splice(index, 1)
      additionalData.value.addl_info_1_list = inputArr1
      break
    }
    case 2: {
      let inputArr2 = [...additionalData.value.addl_info_2_list]
      inputArr2.splice(index, 1)
      additionalData.value.addl_info_2_list = inputArr2
      break
    }

    case 3: {
      let inputArr3 = [...additionalData.value.addl_info_3_list]
      inputArr3.splice(index, 1)
      additionalData.value.addl_info_3_list = inputArr3
      break
    }
    case 4:
      {
        let inputArr4 = [...additionalData.value.addl_info_4_list]
        inputArr4.splice(index, 1)
        additionalData.value.addl_info_4_list = inputArr4
      }
      break
    default: {
      let inputArr5 = [...additionalData.value.addl_info_5_list]
      inputArr5.splice(index, 1)
      additionalData.value.addl_info_5_list = inputArr5
      break
    }
  }
}

watch(
  () => additionalData.value.addl_info_1_type,
  (addl_info_1_type) => {
    if (addl_info_1_type == 0) additionalData.value.addl_info_1_list = ['']
  }
)

watch(
  () => additionalData.value.addl_info_2_type,
  (addl_info_2_type) => {
    if (addl_info_2_type == 0) additionalData.value.addl_info_2_list = ['']
  }
)

watch(
  () => additionalData.value.addl_info_3_type,
  (addl_info_3_type) => {
    if (addl_info_3_type == 0) additionalData.value.addl_info_3_list = ['']
  }
)

watch(
  () => additionalData.value.addl_info_4_type,
  (addl_info_4_type) => {
    if (addl_info_4_type == 0) additionalData.value.addl_info_4_list = ['']
  }
)

watch(
  () => additionalData.value.addl_info_5_type,
  (addl_info_5_type) => {
    if (addl_info_5_type == 0) additionalData.value.addl_info_5_list = ['']
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, {
      breadcrumb: breadcrumb,
      class: "mx-0"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(translate)('formRegSetting')), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(translate)('formRegSetting1')), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(translate)('formRegSetting3')), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(translate)('formRegSetting4')), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(translate)('alumniInvitationUrlIssue')), 1),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(translate)('urlissue1')), 1),
        _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(translate)('urlissue2')), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(translate)('administrativeLabel')), 1),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(invitationKeys.value, (item) => {
            return (_openBlock(), _createBlock(InvitationForm, {
              "invitation-key": item,
              onSetModalData: setModalData,
              key: 'route_name_key_' + item?.invited_route
            }, null, 8, ["invitation-key"]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(translate)('commonItem')), 1),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(translate)('commonItem1')), 1),
        _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(translate)('commonItem2')), 1)
      ]),
      _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(translate)('OE30additionalItems')), 1),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(translate)('participationItem1') + '\n' + _unref(translate)('participationItem2')), 1)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(translate)('forCompanies')), 1),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(translate)('SA20corporationOrganizationName')), 1),
            _createElementVNode("div", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(radio.value, (ra) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "form-check col-4",
                  key: ra.value
                }, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: 'corporationOrganizationName_' + ra.value
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((entry_form.value.corporation_organization_name) = $event)),
                      type: "radio",
                      value: ra.value,
                      id: 'corporationOrganizationName_' + ra.value
                    }, null, 8, _hoisted_27), [
                      [_vModelRadio, entry_form.value.corporation_organization_name]
                    ]),
                    _createTextVNode(" " + _toDisplayString(ra.title), 1)
                  ], 8, _hoisted_26)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("label", _hoisted_29, _toDisplayString(_unref(translate)('SA20department')), 1),
            _createElementVNode("div", _hoisted_30, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(radio.value, (ra) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "form-check col-4",
                  key: ra.value
                }, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: 'department_' + ra.value
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((entry_form.value.corporation_department_name) = $event)),
                      type: "radio",
                      value: ra.value,
                      id: 'department_' + ra.value
                    }, null, 8, _hoisted_32), [
                      [_vModelRadio, entry_form.value.corporation_department_name]
                    ]),
                    _createTextVNode(" " + _toDisplayString(ra.title), 1)
                  ], 8, _hoisted_31)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("label", _hoisted_34, _toDisplayString(_unref(translate)('enrollment')), 1),
            _createElementVNode("div", _hoisted_35, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(radio.value, (ra) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "form-check col-4",
                  key: ra.value
                }, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: 'enrollment_' + ra.value
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((entry_form.value.corporation_period) = $event)),
                      type: "radio",
                      value: ra.value,
                      id: 'enrollment_' + ra.value
                    }, null, 8, _hoisted_37), [
                      [_vModelRadio, entry_form.value.corporation_period]
                    ]),
                    _createTextVNode(" " + _toDisplayString(ra.title), 1)
                  ], 8, _hoisted_36)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("label", _hoisted_39, _toDisplayString(_unref(translate)('SA20employeeID')), 1),
            _createElementVNode("div", _hoisted_40, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(radio.value, (ra) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "form-check col-4",
                  key: ra.value
                }, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: 'employeeID_' + ra.value
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((entry_form.value.corporation_employee_id) = $event)),
                      type: "radio",
                      value: ra.value,
                      id: 'employeeID_' + ra.value
                    }, null, 8, _hoisted_42), [
                      [_vModelRadio, entry_form.value.corporation_employee_id]
                    ]),
                    _createTextVNode(" " + _toDisplayString(ra.title), 1)
                  ], 8, _hoisted_41)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("label", _hoisted_44, _toDisplayString(_unref(translate)('enrolledTimeEmailID')), 1),
            _createElementVNode("div", _hoisted_45, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(radio.value, (ra) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "form-check col-4",
                  key: ra.value
                }, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: 'enrolledTimeEmailID_' + ra.value
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((entry_form.value.corporation_email) = $event)),
                      type: "radio",
                      value: ra.value,
                      id: 'enrolledTimeEmailID_' + ra.value
                    }, null, 8, _hoisted_47), [
                      [_vModelRadio, entry_form.value.corporation_email]
                    ]),
                    _createTextVNode(" " + _toDisplayString(ra.title), 1)
                  ], 8, _hoisted_46)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("label", _hoisted_49, _toDisplayString(_unref(translate)('OE30nameAtTime')), 1),
            _createElementVNode("div", _hoisted_50, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(radio.value, (ra) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "form-check col-4",
                  key: ra.value
                }, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: 'nameAtTime_' + ra.value
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((entry_form.value.corporation_name) = $event)),
                      type: "radio",
                      value: ra.value,
                      id: 'nameAtTime_' + ra.value
                    }, null, 8, _hoisted_52), [
                      [_vModelRadio, entry_form.value.corporation_name]
                    ]),
                    _createTextVNode(" " + _toDisplayString(ra.title), 1)
                  ], 8, _hoisted_51)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, _toDisplayString(_unref(translate)('forSchool')), 1),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("label", _hoisted_56, _toDisplayString(_unref(translate)('SA20schoolOrganizationName')), 1),
            _createElementVNode("div", _hoisted_57, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(radio.value, (ra) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "form-check col-4",
                  key: ra.value
                }, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: 'schoolOrganizationName_' + ra.value
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((entry_form.value.school_organization_name) = $event)),
                      type: "radio",
                      value: ra.value,
                      id: 'schoolOrganizationName_' + ra.value
                    }, null, 8, _hoisted_59), [
                      [_vModelRadio, entry_form.value.school_organization_name]
                    ]),
                    _createTextVNode(" " + _toDisplayString(ra.title), 1)
                  ], 8, _hoisted_58)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("label", _hoisted_61, _toDisplayString(_unref(translate)('SA20facultyName')), 1),
            _createElementVNode("div", _hoisted_62, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(radio.value, (ra) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "form-check col-4",
                  key: ra.value
                }, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: 'facultyName_' + ra.value
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((entry_form.value.school_faclty_name) = $event)),
                      type: "radio",
                      value: ra.value,
                      id: 'facultyName_' + ra.value
                    }, null, 8, _hoisted_64), [
                      [_vModelRadio, entry_form.value.school_faclty_name]
                    ]),
                    _createTextVNode(" " + _toDisplayString(ra.title), 1)
                  ], 8, _hoisted_63)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("label", _hoisted_66, _toDisplayString(_unref(translate)('SA20departmentName')), 1),
            _createElementVNode("div", _hoisted_67, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(radio.value, (ra) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "form-check col-4",
                  key: ra.value
                }, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: 'departmentName_' + ra.value
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((entry_form.value.school_department_name) = $event)),
                      type: "radio",
                      value: ra.value,
                      id: 'departmentName_' + ra.value
                    }, null, 8, _hoisted_69), [
                      [_vModelRadio, entry_form.value.school_department_name]
                    ]),
                    _createTextVNode(" " + _toDisplayString(ra.title), 1)
                  ], 8, _hoisted_68)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("label", _hoisted_71, _toDisplayString(_unref(translate)('SA20periodOfEnrollment')), 1),
            _createElementVNode("div", _hoisted_72, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(radio.value, (ra) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "form-check col-4",
                  key: ra.value
                }, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: 'periodOfEnrollment_' + ra.value
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((entry_form.value.school_period) = $event)),
                      type: "radio",
                      value: ra.value,
                      id: 'periodOfEnrollment_' + ra.value
                    }, null, 8, _hoisted_74), [
                      [_vModelRadio, entry_form.value.school_period]
                    ]),
                    _createTextVNode(" " + _toDisplayString(ra.title), 1)
                  ], 8, _hoisted_73)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("label", _hoisted_76, _toDisplayString(_unref(translate)('SA20studentID')), 1),
            _createElementVNode("div", _hoisted_77, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(radio.value, (ra) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "form-check col-4",
                  key: ra.value
                }, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: 'studentID_' + ra.value
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((entry_form.value.school_student_id) = $event)),
                      type: "radio",
                      value: ra.value,
                      id: 'studentID_' + ra.value
                    }, null, 8, _hoisted_79), [
                      [_vModelRadio, entry_form.value.school_student_id]
                    ]),
                    _createTextVNode(" " + _toDisplayString(ra.title), 1)
                  ], 8, _hoisted_78)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_80, [
            _createElementVNode("label", _hoisted_81, _toDisplayString(_unref(translate)('SA20emailAttendSchool')), 1),
            _createElementVNode("div", _hoisted_82, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(radio.value, (ra) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "form-check col-4",
                  key: ra.value
                }, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: 'emailAttendSchool_' + ra.value
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((entry_form.value.school_email) = $event)),
                      type: "radio",
                      value: ra.value,
                      id: 'emailAttendSchool_' + ra.value
                    }, null, 8, _hoisted_84), [
                      [_vModelRadio, entry_form.value.school_email]
                    ]),
                    _createTextVNode(" " + _toDisplayString(ra.title), 1)
                  ], 8, _hoisted_83)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_85, [
            _createElementVNode("label", _hoisted_86, _toDisplayString(_unref(translate)('SA20nameAtSchool')), 1),
            _createElementVNode("div", _hoisted_87, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(radio.value, (ra) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "form-check col-4",
                  key: ra.value
                }, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: 'nameAtSchool_' + ra.value
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((entry_form.value.school_name) = $event)),
                      type: "radio",
                      value: ra.value,
                      id: 'nameAtSchool_' + ra.value
                    }, null, 8, _hoisted_89), [
                      [_vModelRadio, entry_form.value.school_name]
                    ]),
                    _createTextVNode(" " + _toDisplayString(ra.title), 1)
                  ], 8, _hoisted_88)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_90, [
        _createElementVNode("div", _hoisted_91, [
          _createElementVNode("div", _hoisted_92, _toDisplayString(_unref(translate)('additionalInformation')), 1),
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("label", _hoisted_94, _toDisplayString(_unref(translate)('additionalInformation1Question')), 1),
            _createElementVNode("div", _hoisted_95, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "communityName",
                class: _normalizeClass(['form-control', ngWordAdditionalInformation1Question.value || _unref(v$).additional_information_1_question.$error ? 'is-invalid' : '']),
                placeholder: "入力してください。",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(v$).additional_information_1_question.$model) = $event)),
                onChange: _cache[14] || (_cache[14] = ($event: any) => (checkNgWordAdditionalInformationQuestion(1)))
              }, null, 34), [
                [
                  _vModelText,
                  _unref(v$).additional_information_1_question.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              (ngWordAdditionalInformation1Question.value && !_unref(v$).additional_information_1_question.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_96, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('additionalInformation1Question'),
                params: [1, 50],
                validator: _unref(v$).additional_information_1_question.$errors[0]?.$validator
              }, null, 8, ["title", "validator"])
            ]),
            _createElementVNode("div", _hoisted_97, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(radio.value, (ra) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "form-check col-2 col-ratio",
                  key: ra.value
                }, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: 'additional_information_1_' + ra.value
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((entry_form.value.additional_information_1) = $event)),
                      type: "radio",
                      value: ra.value,
                      id: 'additional_information_1_' + ra.value
                    }, null, 8, _hoisted_99), [
                      [_vModelRadio, entry_form.value.additional_information_1]
                    ]),
                    _createTextVNode(" " + _toDisplayString(ra.title), 1)
                  ], 8, _hoisted_98)
                ]))
              }), 128))
            ]),
            (entry_form.value.additional_information_1 !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                  _withDirectives(_createElementVNode("select", {
                    class: _normalizeClass(["form-select form-select-filter", ['form-control', _unref(vAdd$).addl_info_1_type.$error ? 'is-invalid' : '']]),
                    "aria-label": "Default select example",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((additionalData.value.addl_info_1_type) = $event)),
                    ref: (_value, _refs) => {
                      _refs['selectChild'] = _value
                    }
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ListTypeOption.value, (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.id,
                        key: item.id
                      }, _toDisplayString(item.name), 9, _hoisted_101))
                    }), 128))
                  ], 2), [
                    [_vModelSelect, additionalData.value.addl_info_1_type]
                  ]),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)('additionalInformation1Question'),
                    params: [1, 3],
                    validator: _unref(vAdd$).addl_info_1_type.$errors[0]?.$validator
                  }, null, 8, ["title", "validator"]),
                  (additionalData.value.addl_info_1_type && additionalData.value.addl_info_1_type !== _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(additionalData.value.addl_info_1_list, (itemRow, indexRow) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "row row-option-child mt-2",
                            key: indexRow
                          }, [
                            _createElementVNode("div", _hoisted_103, [
                              _createElementVNode("label", null, _toDisplayString(`${_unref(translate)('option')} ${indexRow + 1}`), 1)
                            ]),
                            _createVNode(OptionForm, {
                              key: "additionalData.addl_info_1_list",
                              "data-item": additionalData.value.addl_info_1_list[indexRow],
                              "index-row": indexRow,
                              "index-option": 1,
                              onUpdateData: ($event: any) => (additionalData.value.addl_info_1_list[indexRow] = $event),
                              onDeleteOptionAction: deleteOptionAction
                            }, null, 8, ["data-item", "index-row", "onUpdateData"])
                          ]))
                        }), 128)),
                        (additionalData.value.addl_info_1_list.length < 10)
                          ? (_openBlock(), _createElementBlock("label", {
                              key: 0,
                              onClick: _cache[17] || (_cache[17] = ($event: any) => (addOptionAction(1))),
                              class: "w-max-content mt-2"
                            }, _toDisplayString(_unref(translate)('addOption')), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_104, [
            _createElementVNode("label", _hoisted_105, _toDisplayString(_unref(translate)('additionalInformation2Question')), 1),
            _createElementVNode("div", _hoisted_106, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "communityName",
                class: _normalizeClass(['form-control', ngWordAdditionalInformation2Question.value || _unref(v$).additional_information_2_question.$error ? 'is-invalid' : '']),
                placeholder: "入力してください。",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(v$).additional_information_2_question.$model) = $event)),
                onChange: _cache[19] || (_cache[19] = ($event: any) => (checkNgWordAdditionalInformationQuestion(2)))
              }, null, 34), [
                [
                  _vModelText,
                  _unref(v$).additional_information_2_question.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              (ngWordAdditionalInformation2Question.value && !_unref(v$).additional_information_2_question.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_107, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('additionalInformation2Question'),
                params: [1, 50],
                validator: _unref(v$).additional_information_2_question.$errors[0]?.$validator
              }, null, 8, ["title", "validator"])
            ]),
            _createElementVNode("div", _hoisted_108, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(radio.value, (ra) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "form-check col-2 col-ratio",
                  key: ra.value
                }, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: 'additional_information_2_' + ra.value
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((entry_form.value.additional_information_2) = $event)),
                      type: "radio",
                      value: ra.value,
                      id: 'additional_information_2_' + ra.value
                    }, null, 8, _hoisted_110), [
                      [_vModelRadio, entry_form.value.additional_information_2]
                    ]),
                    _createTextVNode(" " + _toDisplayString(ra.title), 1)
                  ], 8, _hoisted_109)
                ]))
              }), 128))
            ]),
            (entry_form.value.additional_information_2 !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                  _withDirectives(_createElementVNode("select", {
                    class: _normalizeClass(["form-select form-select-filter", ['form-control', _unref(vAdd$).addl_info_2_type.$error ? 'is-invalid' : '']]),
                    "aria-label": "Default select example",
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((additionalData.value.addl_info_2_type) = $event)),
                    ref: (_value, _refs) => {
                      _refs['selectChild'] = _value
                    }
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ListTypeOption.value, (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.id,
                        key: item.id
                      }, _toDisplayString(item.name), 9, _hoisted_112))
                    }), 128))
                  ], 2), [
                    [_vModelSelect, additionalData.value.addl_info_2_type]
                  ]),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)('additionalInformation2Question'),
                    params: [1, 3],
                    validator: _unref(vAdd$).addl_info_2_type.$errors[0]?.$validator
                  }, null, 8, ["title", "validator"]),
                  (additionalData.value.addl_info_2_type && additionalData.value.addl_info_2_type !== _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(additionalData.value.addl_info_2_list, (itemRow, indexRow) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "row row-option-child mt-2",
                            key: indexRow
                          }, [
                            _createElementVNode("div", _hoisted_114, [
                              _createElementVNode("label", null, _toDisplayString(`${_unref(translate)('option')} ${indexRow + 1}`), 1)
                            ]),
                            _createVNode(OptionForm, {
                              key: "additionalData.addl_info_2_list",
                              "data-item": additionalData.value.addl_info_2_list[indexRow],
                              "index-row": indexRow,
                              "index-option": 2,
                              onUpdateData: ($event: any) => (additionalData.value.addl_info_2_list[indexRow] = $event),
                              onDeleteOptionAction: deleteOptionAction
                            }, null, 8, ["data-item", "index-row", "onUpdateData"])
                          ]))
                        }), 128)),
                        (additionalData.value.addl_info_2_list.length < 10)
                          ? (_openBlock(), _createElementBlock("label", {
                              key: 0,
                              onClick: _cache[22] || (_cache[22] = ($event: any) => (addOptionAction(2))),
                              class: "w-max-content mt-2"
                            }, _toDisplayString(_unref(translate)('addOption')), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_115, [
            _createElementVNode("label", _hoisted_116, _toDisplayString(_unref(translate)('additionalInformation3Question')), 1),
            _createElementVNode("div", _hoisted_117, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "communityName",
                class: _normalizeClass(['form-control', ngWordAdditionalInformation3Question.value || _unref(v$).additional_information_3_question.$error ? 'is-invalid' : '']),
                placeholder: "入力してください。",
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(v$).additional_information_3_question.$model) = $event)),
                onChange: _cache[24] || (_cache[24] = ($event: any) => (checkNgWordAdditionalInformationQuestion(3)))
              }, null, 34), [
                [
                  _vModelText,
                  _unref(v$).additional_information_3_question.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              (ngWordAdditionalInformation3Question.value && !_unref(v$).additional_information_3_question.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_118, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('additionalInformation3Question'),
                params: [1, 50],
                validator: _unref(v$).additional_information_3_question.$errors[0]?.$validator
              }, null, 8, ["title", "validator"])
            ]),
            _createElementVNode("div", _hoisted_119, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(radio.value, (ra) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "form-check col-2 col-ratio",
                  key: ra.value
                }, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: 'additional_information_3_' + ra.value
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((entry_form.value.additional_information_3) = $event)),
                      type: "radio",
                      value: ra.value,
                      id: 'additional_information_3_' + ra.value
                    }, null, 8, _hoisted_121), [
                      [_vModelRadio, entry_form.value.additional_information_3]
                    ]),
                    _createTextVNode(" " + _toDisplayString(ra.title), 1)
                  ], 8, _hoisted_120)
                ]))
              }), 128))
            ]),
            (entry_form.value.additional_information_3 !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                  _withDirectives(_createElementVNode("select", {
                    class: _normalizeClass(["form-select form-select-filter", ['form-control', _unref(vAdd$).addl_info_3_type.$error ? 'is-invalid' : '']]),
                    "aria-label": "Default select example",
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((additionalData.value.addl_info_3_type) = $event)),
                    ref: (_value, _refs) => {
                      _refs['selectChild'] = _value
                    }
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ListTypeOption.value, (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.id,
                        key: item.id
                      }, _toDisplayString(item.name), 9, _hoisted_123))
                    }), 128))
                  ], 2), [
                    [_vModelSelect, additionalData.value.addl_info_3_type]
                  ]),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)('additionalInformation3Question'),
                    params: [1, 3],
                    validator: _unref(vAdd$).addl_info_3_type.$errors[0]?.$validator
                  }, null, 8, ["title", "validator"]),
                  (additionalData.value.addl_info_3_type && additionalData.value.addl_info_3_type !== _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(additionalData.value.addl_info_3_list, (itemRow, indexRow) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "row row-option-child mt-2",
                            key: indexRow
                          }, [
                            _createElementVNode("div", _hoisted_125, [
                              _createElementVNode("label", null, _toDisplayString(`${_unref(translate)('option')} ${indexRow + 1}`), 1)
                            ]),
                            _createVNode(OptionForm, {
                              key: "additionalData.addl_info_3_list",
                              "data-item": additionalData.value.addl_info_3_list[indexRow],
                              "index-row": indexRow,
                              "index-option": 3,
                              onUpdateData: ($event: any) => (additionalData.value.addl_info_3_list[indexRow] = $event),
                              onDeleteOptionAction: deleteOptionAction
                            }, null, 8, ["data-item", "index-row", "onUpdateData"])
                          ]))
                        }), 128)),
                        (additionalData.value.addl_info_3_list.length < 10)
                          ? (_openBlock(), _createElementBlock("label", {
                              key: 0,
                              onClick: _cache[27] || (_cache[27] = ($event: any) => (addOptionAction(3))),
                              class: "w-max-content mt-2"
                            }, _toDisplayString(_unref(translate)('addOption')), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_126, [
            _createElementVNode("label", _hoisted_127, _toDisplayString(_unref(translate)('additionalInformation4Question')), 1),
            _createElementVNode("div", _hoisted_128, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "communityName",
                class: _normalizeClass(['form-control', ngWordAdditionalInformation4Question.value || _unref(v$).additional_information_4_question.$error ? 'is-invalid' : '']),
                placeholder: "入力してください。",
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(v$).additional_information_4_question.$model) = $event)),
                onChange: _cache[29] || (_cache[29] = ($event: any) => (checkNgWordAdditionalInformationQuestion(4)))
              }, null, 34), [
                [
                  _vModelText,
                  _unref(v$).additional_information_4_question.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              (ngWordAdditionalInformation4Question.value && !_unref(v$).additional_information_4_question.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_129, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('additionalInformation4Question'),
                params: [1, 50],
                validator: _unref(v$).additional_information_4_question.$errors[0]?.$validator
              }, null, 8, ["title", "validator"])
            ]),
            _createElementVNode("div", _hoisted_130, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(radio.value, (ra) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "form-check col-2 col-ratio",
                  key: ra.value
                }, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: 'additional_information_4_' + ra.value
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((entry_form.value.additional_information_4) = $event)),
                      type: "radio",
                      value: ra.value,
                      id: 'additional_information_4_' + ra.value
                    }, null, 8, _hoisted_132), [
                      [_vModelRadio, entry_form.value.additional_information_4]
                    ]),
                    _createTextVNode(" " + _toDisplayString(ra.title), 1)
                  ], 8, _hoisted_131)
                ]))
              }), 128))
            ]),
            (entry_form.value.additional_information_4 !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                  _withDirectives(_createElementVNode("select", {
                    class: _normalizeClass(["form-select form-select-filter", ['form-control', _unref(vAdd$).addl_info_4_type.$error ? 'is-invalid' : '']]),
                    "aria-label": "Default select example",
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((additionalData.value.addl_info_4_type) = $event)),
                    ref: (_value, _refs) => {
                      _refs['selectChild'] = _value
                    }
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ListTypeOption.value, (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.id,
                        key: item.id
                      }, _toDisplayString(item.name), 9, _hoisted_134))
                    }), 128))
                  ], 2), [
                    [_vModelSelect, additionalData.value.addl_info_4_type]
                  ]),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)('additionalInformation4Question'),
                    params: [1, 3],
                    validator: _unref(vAdd$).addl_info_4_type.$errors[0]?.$validator
                  }, null, 8, ["title", "validator"]),
                  (additionalData.value.addl_info_4_type && additionalData.value.addl_info_4_type !== _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(additionalData.value.addl_info_4_list, (itemRow, indexRow) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "row row-option-child mt-2",
                            key: indexRow
                          }, [
                            _createElementVNode("div", _hoisted_136, [
                              _createElementVNode("label", null, _toDisplayString(`${_unref(translate)('option')} ${indexRow + 1}`), 1)
                            ]),
                            _createVNode(OptionForm, {
                              key: "additionalData.addl_info_4_list",
                              "data-item": additionalData.value.addl_info_4_list[indexRow],
                              "index-row": indexRow,
                              "index-option": 4,
                              onUpdateData: ($event: any) => (additionalData.value.addl_info_4_list[indexRow] = $event),
                              onDeleteOptionAction: deleteOptionAction
                            }, null, 8, ["data-item", "index-row", "onUpdateData"])
                          ]))
                        }), 128)),
                        (additionalData.value.addl_info_4_list.length < 10)
                          ? (_openBlock(), _createElementBlock("label", {
                              key: 0,
                              onClick: _cache[32] || (_cache[32] = ($event: any) => (addOptionAction(4))),
                              class: "w-max-content mt-2"
                            }, _toDisplayString(_unref(translate)('addOption')), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_137, [
            _createElementVNode("label", _hoisted_138, _toDisplayString(_unref(translate)('additionalInformation5Question')), 1),
            _createElementVNode("div", _hoisted_139, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "communityName",
                class: _normalizeClass(['form-control', ngWordAdditionalInformation5Question.value || _unref(v$).additional_information_5_question.$error ? 'is-invalid' : '']),
                placeholder: "入力してください。",
                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_unref(v$).additional_information_5_question.$model) = $event)),
                onChange: _cache[34] || (_cache[34] = ($event: any) => (checkNgWordAdditionalInformationQuestion(5)))
              }, null, 34), [
                [
                  _vModelText,
                  _unref(v$).additional_information_5_question.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              (ngWordAdditionalInformation5Question.value && !_unref(v$).additional_information_5_question.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_140, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('additionalInformation5Question'),
                params: [1, 50],
                validator: _unref(v$).additional_information_5_question.$errors[0]?.$validator
              }, null, 8, ["title", "validator"])
            ]),
            _createElementVNode("div", _hoisted_141, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(radio.value, (ra) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "form-check col-2 col-ratio",
                  key: ra.value
                }, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: 'additional_information_5_' + ra.value
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((entry_form.value.additional_information_5) = $event)),
                      type: "radio",
                      value: ra.value,
                      id: 'additional_information_5_' + ra.value
                    }, null, 8, _hoisted_143), [
                      [_vModelRadio, entry_form.value.additional_information_5]
                    ]),
                    _createTextVNode(" " + _toDisplayString(ra.title), 1)
                  ], 8, _hoisted_142)
                ]))
              }), 128))
            ]),
            (entry_form.value.additional_information_5 !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                  _withDirectives(_createElementVNode("select", {
                    class: _normalizeClass(["form-select form-select-filter", ['form-control', _unref(vAdd$).addl_info_5_type.$error ? 'is-invalid' : '']]),
                    "aria-label": "Default select example",
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((additionalData.value.addl_info_5_type) = $event)),
                    ref: (_value, _refs) => {
                      _refs['selectChild'] = _value
                    }
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ListTypeOption.value, (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.id,
                        key: item.id
                      }, _toDisplayString(item.name), 9, _hoisted_145))
                    }), 128))
                  ], 2), [
                    [_vModelSelect, additionalData.value.addl_info_5_type]
                  ]),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)('additionalInformation5Question'),
                    params: [1, 3],
                    validator: _unref(vAdd$).addl_info_5_type.$errors[0]?.$validator
                  }, null, 8, ["title", "validator"]),
                  (additionalData.value.addl_info_5_type && additionalData.value.addl_info_5_type !== _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(additionalData.value.addl_info_5_list, (itemRow, indexRow) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "row row-option-child mt-2",
                            key: indexRow
                          }, [
                            _createElementVNode("div", _hoisted_147, [
                              _createElementVNode("label", null, _toDisplayString(`${_unref(translate)('option')} ${indexRow + 1}`), 1)
                            ]),
                            _createVNode(OptionForm, {
                              key: "additionalData.addl_info_5_list",
                              "data-item": additionalData.value.addl_info_5_list[indexRow],
                              "index-row": indexRow,
                              "index-option": 5,
                              onUpdateData: ($event: any) => (additionalData.value.addl_info_5_list[indexRow] = $event),
                              onDeleteOptionAction: deleteOptionAction
                            }, null, 8, ["data-item", "index-row", "onUpdateData"])
                          ]))
                        }), 128)),
                        (additionalData.value.addl_info_5_list.length < 10)
                          ? (_openBlock(), _createElementBlock("label", {
                              key: 0,
                              onClick: _cache[37] || (_cache[37] = ($event: any) => (addOptionAction(5))),
                              class: "w-max-content mt-2"
                            }, _toDisplayString(_unref(translate)('addOption')), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_148, [
        _createElementVNode("p", _hoisted_149, _toDisplayString(_unref(translate)('formRegSetting5')), 1),
        _createElementVNode("p", _hoisted_150, _toDisplayString(_unref(translate)('formRegSetting7')), 1)
      ]),
      _createElementVNode("div", _hoisted_151, [
        _createElementVNode("div", _hoisted_152, [
          _createElementVNode("div", _hoisted_153, _toDisplayString(_unref(translate)('supplementaryInformation')), 1),
          _createElementVNode("div", _hoisted_154, [
            _createElementVNode("div", _hoisted_155, [
              _withDirectives(_createElementVNode("textarea", {
                id: "supplementaryInfo",
                name: "supplementaryInfo",
                class: _normalizeClass(['form-control', ngKeySupplementaryInfo.value || _unref(v$).supplementary_information.$error ? 'is-invalid' : '']),
                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_unref(v$).supplementary_information.$model) = $event)),
                rows: "4",
                placeholder: _unref(translate)('placeholder'),
                onChange: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_unref(checkNGSupplementaryInfo) && _unref(checkNGSupplementaryInfo)(...args)))
              }, null, 42, _hoisted_156), [
                [_vModelText, _unref(v$).supplementary_information.$model]
              ]),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('additionalInformation'),
                params: [1, 1000],
                validator: _unref(v$).supplementary_information.$errors[0]?.$validator
              }, null, 8, ["title", "validator"]),
              (ngKeySupplementaryInfo.value && !_unref(v$).supplementary_information.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_157, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_158, [
        _createElementVNode("p", _hoisted_159, _toDisplayString(_unref(translate)('formRegSetting8') + '\n' + _unref(translate)('formRegSetting9')), 1)
      ]),
      _createElementVNode("div", _hoisted_160, [
        _createElementVNode("div", _hoisted_161, [
          _createVNode(Button, {
            title: _unref(translate)('confirm'),
            type: 'secondary',
            className: 'fw-bold',
            onClick: onSubmit
          }, null, 8, ["title"])
        ])
      ])
    ]),
    _createVNode(SocialModal, { data: modalData.value }, null, 8, ["data"]),
    _createVNode(ConfirmModal, {
      data: entry_form.value,
      "invitation-keys": invitationKeys.value,
      ref: (_value, _refs) => {
        _refs['modalRef'] = _value
        modalRef.value = _value
      },
      additionalData: additionalData.value
    }, null, 8, ["data", "invitation-keys", "additionalData"])
  ], 64))
}
}

})